// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1LQJE","left":"StickyBox_left__2GnLg","right":"StickyBox_right__2Bz3B"};